//@ts-nocheck
import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import DefaultDoughnutChart from "lib/Charts/DoughnutCharts/DefaultDoughnutChart";
import { formatCurrencyUSD } from "utils/CommonUtils";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import CollapsibleCard from "components/CollapsibleCard";
import moment from "moment";
import { calculateWorkingDays, getCalendarDateFromBusinessDays } from "utils/CalanderUtils";
import { get, post, request } from "../../requests";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  IconButton,
  OutlinedInput,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MDInput from "components/MDInput";
import { NumericFormat } from "react-number-format";
import { useStoreState, useStoreActions } from "easy-peasy";
import { useSubmissionStore } from "models/applications/SubmissionStore";
import FullPageLoader from "components/Loader/FullPage";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import { ba } from "@fullcalendar/core/internal-common";
import { convertNumeric } from "utils/CommonUtils";

const offersFundingCalculator: React.FC<any> = ({
  mode,
  setMode,
  open,
  setOpen,
  dealApplicationId,
  offerId,
  formData,
  setFormData,
  debits,
  setDebits,
  scheduleFrequency,
  setScheduleFrequency,
  contractTerms,
  setContractTerms,
  MAX_FUNDER_HOLDBACK,
  SET_MAX_FUNDER_HOLDBACK,
  refreshOffers,
}) => {
  const [scoreboard, setScoreboard] = useState({});
  const [triggerRecurringAmountChange, setTriggerRecurringAmountChange] = useState(false);
  const isPurchasePriceTypingRef = useRef(false);
  const isFactorTypingRef = useRef(false);
  const isFundingAmountTypingRef = useRef(false);
  const hasMounted = useRef(false);
  const [isRefi, setIsRefi] = useState<boolean>(false);
  const [currentMCAHoldback, setcurrentMCAHoldback] = useState<any>(formData?.leverage || 0);
  const [availableHoldBack, setAvailableHoldBack] = useState<any>(0);
  const [isLoading, setLoading] = useState<boolean>(false);
  const saveFinalOffer = useStoreActions((actions: any) => actions.offerStore.saveContractTerms);
  const [debounceTimeout, setDebounceTimeout] = useState<NodeJS.Timeout | null>(null);
  const [externalFunders, setExternalFunders] = useState<any>([]);
  const [heldbacks, setHeldbacks] = useState<any>([]);

  const [textData, setTextData] = useState({
    "Net Funding": "",
    "Total Financing Cost": "",
  });

  const [advancesResponse, setAdvancesResponse] = useState<any>([]);
  const [bankStatementSummary, setBankStatementsSummary] = useState<any>([]);

  const addOffer = useStoreActions((actions) => actions.offerStore.createOrUpdateOffer);

  const fetchRecalculatedApplication = useStoreActions(
    (actions: any) => actions.offerStore.fetchRecalculatedApplication
  );
  const handleBankAmountUpdate = useStoreActions(
    (actions: any) => actions.heldBackCommissionStore.handleForTotalBankFeeOrInvestorEditChanges
  );
  const updateSyndicatorsPercentage = useStoreActions(
    (actions: any) => actions.syndicationStore.updateSyndicatorsPercentage
  );

  const saveHeldback = useStoreActions(
    (actions: any) => actions.heldBackCommissionStore.saveHeldback
  );

  const deleteHeldBack = useStoreActions(
    (actions: any) => actions.heldBackCommissionStore.deleteCommission
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        if (
          contractTerms?.contractTerms?.payingOffDeals &&
          contractTerms?.contractTerms?.payingOffDeals?.length > 0
        ) {
          setIsRefi(true);

          let existingRefiAmount = formData?.totalRefinance;

          if (!existingRefiAmount) {
            existingRefiAmount = contractTerms?.contractTerms?.parentDealAmount || 0;
          }

          setFormData((prevData) => ({
            ...prevData,
            totalRefinance: existingRefiAmount,
          }));
        }

        const advances = await getAdvancesAndPosition();
        const bankSummary = await fetchBankStatementsSummary();
        await loadExternalFunders();
        await loadHeldbacks();
        await populateScorecaredBasedonData(advances, bankSummary);
      } catch (error) {
        console.error("Error fetching contract terms or offer:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [open, contractTerms]);

  useEffect(() => {
    setcurrentMCAHoldback(scoreboard?.monthlyMCAHoldback || 0);
    const leverage = formData?.leverage || scoreboard?.monthlyMCAHoldback || 0;
    const availableHoldback = Math.max(0, MAX_FUNDER_HOLDBACK - (leverage || 0));
    const averageTrueDeposit = scoreboard?.averageTrueDeposits ?? 0;
    setAvailableHoldBack(averageTrueDeposit === 0 ? 0 : availableHoldback);

    setFormData((prevData) => ({
      ...prevData,
      leverage: leverage,
    }));
  }, [scoreboard, open]);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }
    const debitAmount = calculateRecurringAmountFromLeverage(availableHoldBack);
    handleAmountChange(debitAmount);
  }, [scheduleFrequency]);

  useEffect(() => {
    const safeValue = (value: any) => (isNaN(value) || value == null ? 0 : value);
    const fundingAmount = isNaN(formData?.fundingAmount) ? 0 : formData?.fundingAmount;
    const purchaseAmount = isNaN(formData?.purchasePrice) ? 0 : formData?.purchasePrice;

    if (!fundingAmount || !purchaseAmount || purchaseAmount <= 0) {
      setTextData({
        "Net Funding": "",
        "Total Financing Cost": "",
      });
    }

    const bankFee = isNaN(formData?.bankFeeAmount) ? 0 : formData?.bankFeeAmount;
    const totalFees = isNaN(formData?.totalFees) ? 0 : formData?.totalFees;

    const netFunding =
      safeValue(formData?.fundingAmount) -
      safeValue(formData?.bankFeeAmount) -
      safeValue(formData?.totalFees) -
      safeValue(formData?.totalExternalPayoff) -
      safeValue(formData?.totalRefinance);
    const totalFinancingCost = purchaseAmount - netFunding;

    setTextData({
      "Net Funding": formatCurrencyUSD(netFunding),
      "Total Financing Cost": formatCurrencyUSD(totalFinancingCost),
    });
  }, [formData]);

  const loadHeldbacks = async () => {
    const response = await post("fetchApplicationHeldbacks", { applicationId: dealApplicationId });
    const responseData = response["heldbacks"];
    if (responseData) {
      setHeldbacks(responseData);
    }
  };

  const loadExternalFunders = async () => {
    const tenantId = localStorage.getItem("tenantId");
    const response = await get(`fetchExternalFunders/${tenantId}`);
    setExternalFunders(response || []);
  };

  const getAdvancesAndPosition = async () => {
    const response = await get(`/bankStatements/getAllAdvances/${dealApplicationId}`);

    if (Array.isArray(response)) {
      const dataWithSelection = response.map((row) => ({
        ...row,
        selected: row.status === "Active",
      }));
      setAdvancesResponse(dataWithSelection);
      return dataWithSelection;
    } else {
      setAdvancesResponse([]);
      return [];
    }
  };

  const fetchBankStatementsSummary = async () => {
    try {
      const response = await get(`/ocr/transactionSummary/${dealApplicationId}`);
      setBankStatementsSummary(response || []);
      return response;
    } catch {
      setBankStatementsSummary([]);
      return [];
    }
  };

  const populateScorecaredBasedonData = async (advancesData: any, bankStatementData: any) => {
    let totalRevenue = 0;
    let totalTrueDeposits = 0;
    let totalNonTrueDeposits = 0;
    let totalExpenses = 0;
    let totalGrossProfit = 0;
    let mcaHoldback = 0;
    let totalMonthlyDebits = 0;

    advancesData
      .filter((adv) => adv?.selected)
      .forEach((advance: any) => {
        totalMonthlyDebits += convertNumeric(advance.monthlyAmount) || 0;
      });

    bankStatementData.forEach((statement: any) => {
      totalRevenue += convertNumeric(statement.totalCredits) || 0;
      totalTrueDeposits += convertNumeric(statement.totalTrueCredits) || 0;
      totalNonTrueDeposits +=
        convertNumeric(statement.totalCredits) - convertNumeric(statement.totalTrueCredits) || 0;
      totalExpenses += convertNumeric(statement.totalDebits) || 0;
      totalGrossProfit +=
        convertNumeric(statement.totalCredits) - convertNumeric(statement.totalDebits) || 0;
    });

    const numStatements = bankStatementData?.length;

    const averageTrueDeposits = numStatements > 0 ? totalTrueDeposits / numStatements : 0;

    if (averageTrueDeposits > 0) {
      mcaHoldback = (totalMonthlyDebits / averageTrueDeposits) * 100;
      mcaHoldback = parseFloat(mcaHoldback.toFixed(2));
    }

    setScoreboard({
      averageMonthlyRevenue:
        numStatements > 0 ? Math.round((totalRevenue / numStatements) * 100) / 100 : 0,
      averageTrueDeposits:
        numStatements > 0 ? Math.round((totalTrueDeposits / numStatements) * 100) / 100 : 0,
      averageNonTrueDeposits:
        numStatements > 0 ? Math.round((totalNonTrueDeposits / numStatements) * 100) / 100 : 0,
      averageMonthlyExpenses:
        numStatements > 0 ? Math.round((totalExpenses / numStatements) * 100) / 100 : 0,
      averageGrossProfit:
        numStatements > 0 ? Math.round((totalGrossProfit / numStatements) * 100) / 100 : 0,
      totalMonthlyDebits: Math.round(totalMonthlyDebits * 100) / 100,
      monthlyMCAHoldback: Math.round(mcaHoldback * 100) / 100,
      availableHoldBack:
        Math.round(((MAX_FUNDER_HOLDBACK || 0) - (mcaHoldback ? mcaHoldback : 0)) * 100) / 100,
      positions: advancesData?.filter((adv) => adv.fundedAmount && adv.fundedAmount > 0).length,
    });
  };

  const calculateLeverageFromCurrentValues = (newDebits: any) => {
    const { recurringAmount } = newDebits[scheduleFrequency];
    const averageTrueDeposits = scoreboard?.averageTrueDeposits || 0;

    if (!averageTrueDeposits || !recurringAmount) return 0;

    const recurringAmountFloat = parseFloat(recurringAmount);

    if (isNaN(recurringAmountFloat)) return 0;

    let monthlyDebit;
    switch (scheduleFrequency) {
      case "daily":
        monthlyDebit = recurringAmountFloat * 5 * 4.33;
        break;
      case "weekly":
        monthlyDebit = recurringAmountFloat * 4.33;
        break;
      case "monthly":
        monthlyDebit = recurringAmountFloat;
        break;
      default:
        return 0;
    }

    return parseFloat(((monthlyDebit / averageTrueDeposits) * 100).toFixed(2));
  };

  const greenPercentage = useMemo(() => {
    const leverage = formData?.leverage ?? 0;
    const maxHoldback = MAX_FUNDER_HOLDBACK ?? 0;

    if (leverage === 0) return 0;

    return (maxHoldback / leverage) * 100;
  }, [formData?.leverage, MAX_FUNDER_HOLDBACK]);

  const calculateRecurringAmountFromLeverage = (leveragePercent: any) => {
    const averageTrueDeposits = scoreboard?.averageTrueDeposits || 0;

    if (!averageTrueDeposits || !leveragePercent) return 0;

    const monthlyDebit = (leveragePercent / 100) * averageTrueDeposits;

    let recurringAmount;

    switch (scheduleFrequency) {
      case "daily":
        recurringAmount = monthlyDebit / (5 * 4.33);
        break;
      case "weekly":
        recurringAmount = monthlyDebit / 4.33;
        break;
      case "monthly":
        recurringAmount = monthlyDebit;
        break;
      default:
        return 0;
    }

    return parseFloat(recurringAmount.toFixed(2));
  };

  const handleLeverageChange = (e: any, newValue: any) => {
    let leverage = newValue;
    const averageTrueDeposits = scoreboard?.averageTrueDeposits || 0;
    let deltaLeverage = leverage - currentMCAHoldback;
    setAvailableHoldBack(deltaLeverage);

    if (averageTrueDeposits) {
      let debit = calculateRecurringAmountFromLeverage(deltaLeverage);
      setFormData((prevData) => ({
        ...prevData,
        leverage: leverage,
      }));
      handleAmountChange(debit, false);
    }
  };

  const calculateChartData = useCallback(() => {
    const safeValue = (value: any) => (isNaN(value) || value == null ? 0 : value);
    const fundingAmount = safeValue(formData?.fundingAmount);
    const purchaseAmount = safeValue(formData?.purchasePrice);

    if (!fundingAmount || !purchaseAmount || purchaseAmount <= 0) {
      return {
        label: "Funding Chart",
        backgroundColors: isRefi
          ? ["#E93B77", "#3E3D45", "#1E78E9", "#FEA321", "#4BA64F", "#FBE603"]
          : ["#E93B77", "#3E3D45", "#1E78E9", "#4BA64F", "#FBE603"],
        data: isRefi ? [0, 0, 0, 0, 0, 0] : [0, 0, 0, 0, 0],
      };
    }

    const netFunding =
      safeValue(formData?.fundingAmount) -
      safeValue(formData?.bankFeeAmount) -
      safeValue(formData?.totalFees) -
      safeValue(formData?.totalExternalPayoff) -
      safeValue(formData?.totalRefinance);

    const bankFee = safeValue(formData?.bankFeeAmount);
    const comission = safeValue(formData?.totalCommissionAmount);
    const profit = purchaseAmount - fundingAmount - comission;
    const externalPayOff = safeValue(formData?.totalExternalPayoff);
    const refinance = safeValue(formData?.totalRefinance);
    const totalFees = safeValue(formData?.totalFees) + safeValue(formData?.bankFeeAmount);

    //percentages
    const netfundingPercent = purchaseAmount > 0 ? (netFunding / purchaseAmount) * 100 : 0;
    const bankFeePercentage = purchaseAmount > 0 ? (bankFee / purchaseAmount) * 100 : 0;
    const feePercenatge = purchaseAmount > 0 ? (totalFees / purchaseAmount) * 100 : 0;
    const commisionPercentage = purchaseAmount > 0 ? (comission / purchaseAmount) * 100 : 0;
    const profitPercentage = purchaseAmount > 0 ? (profit / purchaseAmount) * 100 : 0;
    const externalPayOffPercentage =
      purchaseAmount > 0 ? (externalPayOff / purchaseAmount) * 100 : 0;
    const refinancePercentage = purchaseAmount > 0 ? (refinance / purchaseAmount) * 100 : 0;
    return {
      label: "Funding Chart",
      backgroundColors: isRefi
        ? ["#E93B77", "#3E3D45", "#1E78E9", "#FEA321", "#4BA64F", "#FBE603"]
        : ["#E93B77", "#3E3D45", "#1E78E9", "#4BA64F", "#FBE603"],
      data: isRefi
        ? [
            profitPercentage,
            netfundingPercent,
            feePercenatge,
            refinancePercentage,
            externalPayOffPercentage,
            commisionPercentage,
          ]
        : [
            profitPercentage,
            netfundingPercent,
            feePercenatge,
            externalPayOffPercentage,
            commisionPercentage,
          ],
    };
  }, [formData, isRefi]);

  const resetFields = () => {
    hasMounted.current = false;
    setFormData({
      fundingAmount: 0,
      factor: 0,
      purchasePrice: 0,
      bankFeePercentage: 0,
      bankFeeAmount: 0,
      totalCommissionPercentage: 0,
      leverage: 0,
      totalCommissionAmount: 0,
      totalRefinance: 0,
      totalExternalPayoff: 0,
      totalFees: 0,
      position: 0,
      fundingDate: new Date().toISOString().split("T")[0],
      specifiedPercentage: 0,
    });

    setDebits({
      daily: {
        recurringAmount: "",
        numTerms: "",
        totalBankDays: "",
        lastPaymentDate: "",
      },
      weekly: {
        recurringAmount: "",
        numTerms: "",
        totalBankDays: "",
        lastPaymentDate: "",
      },
      monthly: {
        recurringAmount: "",
        numTerms: "",
        totalBankDays: "",
        lastPaymentDate: "",
      },
    });
    setAdvancesResponse([]);
    setAvailableHoldBack(0);
    setIsRefi(false);
    setScheduleFrequency("weekly");
    if (typeof setMode === "function" && typeof mode !== "undefined") {
      setMode("");
    }
    setContractTerms({});
    setBankStatementsSummary([]);
  };

  const adjusDebitAmountBasedOnFixedTerm = (adjustedFormData: any) => {
    const newPurchaseAmount = adjustedFormData?.purchasePrice;
    const val = debits?.daily?.numTerms;
    if (!val || Number(val) <= 0) {
      return;
    }
    if (!newPurchaseAmount || Number(newPurchaseAmount) <= 0) {
      return;
    }

    const today = moment().format("YYYY-MM-DD");
    const offset = Number(val);
    const newDate = moment().add(offset, "days").format("YYYY-MM-DD");
    let totalBankDays = Number(calculateWorkingDays(today, newDate)) - 1;
    let recurringAmount = Number(newPurchaseAmount) / totalBankDays;
    let recurringAmoutForWeekMonth = Number(newPurchaseAmount) / offset;
    let lastPaymentDate = moment().add(val, "days").format("YYYY-MM-DD");

    setDebits({
      daily: {
        recurringAmount: (Math.ceil(recurringAmount * 100) / 100).toFixed(2),
        numTerms: val,
        totalBankDays: totalBankDays,
        lastPaymentDate: lastPaymentDate,
      },
      weekly: {
        recurringAmount: (Math.ceil(recurringAmoutForWeekMonth * 100) / 100).toFixed(2),
        numTerms: val,
        totalBankDays: val,
        lastPaymentDate: moment()
          .add(offset * 7, "days")
          .format("YYYY-MM-DD"),
      },
      monthly: {
        recurringAmount: (Math.ceil(recurringAmoutForWeekMonth * 100) / 100).toFixed(2),
        numTerms: val,
        totalBankDays: val,
        lastPaymentDate: moment()
          .add(offset * 30, "days")
          .format("YYYY-MM-DD"),
      },
    });
  };

  const adjustTermsBasedOnFixedDebit = (adjustedFormData: any, debitAmount: any) => {
    const newPurchaseAmount = adjustedFormData?.purchasePrice;
    const rawVal = debitAmount;
    if (!rawVal || rawVal <= 0 || isNaN(rawVal)) return;
    if (!newPurchaseAmount || Number(newPurchaseAmount) <= 0) {
      return;
    }
    const val = Math.round(rawVal * 100) / 100;
    if (!val || val <= 0) {
      setDebits((prevState) => ({
        ...prevState,
        [scheduleFrequency]: {
          ...prevState[scheduleFrequency],
          recurringAmount: "",
          numTerms: 0,
          totalBankDays: 0,
          lastPaymentDate: "",
        },
      }));
      return;
    }

    const purchaseAmount = newPurchaseAmount;
    const offset = Math.ceil(purchaseAmount / val);
    const startDate = moment();
    const termsResult = getCalendarDateFromBusinessDays(startDate.format("YYYY-MM-DD"), offset);

    const estimatedPaymentDate = termsResult?.resultDate;
    const terms = termsResult?.totalCalendarDays;
    const newDebits = {
      daily: {
        recurringAmount: val,
        numTerms: terms,
        totalBankDays: offset,
        lastPaymentDate: moment(estimatedPaymentDate).format("YYYY-MM-DD"),
      },
      weekly: {
        recurringAmount: val,
        numTerms: offset,
        totalBankDays: offset,
        lastPaymentDate: moment()
          .add(offset * 7, "days")
          .format("YYYY-MM-DD"),
      },
      monthly: {
        recurringAmount: val,
        numTerms: offset,
        totalBankDays: offset,
        lastPaymentDate: moment()
          .add(offset * 30, "days")
          .format("YYYY-MM-DD"),
      },
    };

    setDebits(newDebits);
  };

  const handleAmountChange = (val: any, updateLeverage: boolean) => {
    val = Number(val);

    if (!val || val <= 0) {
      setDebits((prevState) => ({
        ...prevState,
        [scheduleFrequency]: {
          ...prevState[scheduleFrequency],
          recurringAmount: "",
          numTerms: 0,
          totalBankDays: 0,
          lastPaymentDate: "",
        },
      }));
      return;
    }

    const purchaseAmount = formData?.purchasePrice;
    const offset = Math.ceil(purchaseAmount / val);
    const startDate = moment();

    const termsResult = getCalendarDateFromBusinessDays(startDate.format("YYYY-MM-DD"), offset);

    const estimatedPaymentDate = termsResult?.resultDate;
    const terms = termsResult?.totalCalendarDays;
    const newDebits = {
      daily: {
        recurringAmount: val,
        numTerms: terms,
        totalBankDays: offset,
        lastPaymentDate: moment(estimatedPaymentDate).format("YYYY-MM-DD"),
      },
      weekly: {
        recurringAmount: val,
        numTerms: offset,
        totalBankDays: offset,
        lastPaymentDate: moment()
          .add(offset * 7, "days")
          .format("YYYY-MM-DD"),
      },
      monthly: {
        recurringAmount: val,
        numTerms: offset,
        totalBankDays: offset,
        lastPaymentDate: moment()
          .add(offset * 30, "days")
          .format("YYYY-MM-DD"),
      },
    };

    setDebits(newDebits);

    if (updateLeverage) {
      const newLeverage = parseFloat(calculateLeverageFromCurrentValues(newDebits).toFixed(2));
      const newTotalHoldback = parseFloat((newLeverage + currentMCAHoldback).toFixed(2));

      setFormData((prevData) => ({
        ...prevData,
        leverage: newTotalHoldback,
      }));
      setAvailableHoldBack(newLeverage);
    }
  };

  const debouncedHandleAmountChange = (value: number) => {
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    const newDebounceTimeout = setTimeout(() => {
      handleAmountChange(value, true);
    }, 1500);

    setDebounceTimeout(newDebounceTimeout);
  };

  const debouncedFundingAmountChange = (value: number) => {
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    const newDebounceTimeout = setTimeout(() => {
      handleFundingAmountChange(value);
    }, 2000);

    setDebounceTimeout(newDebounceTimeout);
  };

  const debouncedPurchaseAmountChange = (value: number) => {
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    const newDebounceTimeout = setTimeout(() => {
      handlePurchaseAmountChange(value);
    }, 2000);

    setDebounceTimeout(newDebounceTimeout);
  };

  const handleEstimatedPayOffDate = (event: any) => {
    const estimatedDate = event?.target?.value;
    const purchaseAmount = formData?.purchasePrice;

    if (!purchaseAmount || purchaseAmount <= 0) {
      console.log("Invalid purchase amount.");
      return;
    }

    const momentToday = moment().startOf("day");
    const estimatedMoment = moment(estimatedDate).startOf("day");
    const numTerms = estimatedMoment.diff(momentToday, "days");

    if (numTerms <= 0) {
      console.log("The estimated date must be in the future.");
      return;
    }

    let today = moment().format("YYYY-MM-DD");
    const numBusinessDays = calculateWorkingDays(today, estimatedDate);
    let dailyRecurringAmount = purchaseAmount / numBusinessDays;

    let numWeeks = Math.ceil(numTerms / 7);
    let weeklyRecurringAmount = purchaseAmount / numWeeks;

    let numMonths = Math.ceil(numTerms / 30);
    let monthlyRecurringAmount = purchaseAmount / numMonths;

    const newDebits = {
      daily: {
        recurringAmount: (Math.ceil(dailyRecurringAmount * 100) / 100).toFixed(2),
        numTerms: numTerms,
        totalBankDays: numBusinessDays,
        lastPaymentDate: estimatedDate,
      },
      weekly: {
        recurringAmount: (Math.ceil(weeklyRecurringAmount * 100) / 100).toFixed(2),
        numTerms: numWeeks,
        totalBankDays: numWeeks,
        lastPaymentDate: estimatedDate,
      },
      monthly: {
        recurringAmount: (Math.ceil(monthlyRecurringAmount * 100) / 100).toFixed(2),
        numTerms: numMonths,
        totalBankDays: numMonths,
        lastPaymentDate: estimatedDate,
      },
    };

    setDebits(newDebits);

    const newLeverage = parseFloat(calculateLeverageFromCurrentValues(newDebits).toFixed(2));
    const newTotalHoldback = parseFloat((newLeverage + currentMCAHoldback).toFixed(2));

    setFormData((prevData) => ({
      ...prevData,
      leverage: newTotalHoldback,
    }));
    setAvailableHoldBack(newLeverage);
  };

  const handleTermChange = (val) => {
    val = Number(val);

    if (!val || Number(val) <= 0) {
      setDebits((prevState) => ({
        ...prevState,
        [scheduleFrequency]: {
          ...prevState[scheduleFrequency],
          recurringAmount: "",
          numTerms: 0,
          totalBankDays: 0,
          lastPaymentDate: "",
        },
      }));
      return;
    }
    const purchaseAmount = formData?.purchasePrice;

    const today = moment().format("YYYY-MM-DD");
    const offset = Number(val);
    const newDate = moment().add(offset, "days").format("YYYY-MM-DD");
    let totalBankDays = calculateWorkingDays(today, newDate);
    let recurringAmount = Number(purchaseAmount) / totalBankDays;
    let recurringAmoutForWeekMonth = Number(purchaseAmount) / offset;
    let lastPaymentDate = moment().add(val, "days").format("YYYY-MM-DD");

    const newDebits = {
      daily: {
        recurringAmount: (Math.ceil(recurringAmount * 100) / 100).toFixed(2),
        numTerms: val,
        totalBankDays: totalBankDays,
        lastPaymentDate: lastPaymentDate,
      },
      weekly: {
        recurringAmount: (Math.ceil(recurringAmoutForWeekMonth * 100) / 100).toFixed(2),
        numTerms: val,
        totalBankDays: val,
        lastPaymentDate: moment()
          .add(offset * 7, "days")
          .format("YYYY-MM-DD"),
      },
      monthly: {
        recurringAmount: (Math.ceil(recurringAmoutForWeekMonth * 100) / 100).toFixed(2),
        numTerms: val,
        totalBankDays: val,
        lastPaymentDate: moment()
          .add(offset * 30, "days")
          .format("YYYY-MM-DD"),
      },
    };

    setDebits(newDebits);

    const newLeverage = parseFloat(calculateLeverageFromCurrentValues(newDebits).toFixed(2));
    const newTotalHoldback = parseFloat((newLeverage + currentMCAHoldback).toFixed(2));

    setFormData((prevData) => ({
      ...prevData,
      leverage: newTotalHoldback,
    }));
    setAvailableHoldBack(newLeverage);
  };

  const handleBankDaysChange = (val) => {
    val = Number(val);
    if (!val || val <= 0) {
      setDebits((prevState) => ({
        ...prevState,
        [scheduleFrequency]: {
          ...prevState[scheduleFrequency],
          recurringAmount: "",
          numTerms: 0,
          totalBankDays: 0,
          lastPaymentDate: "",
        },
      }));
      return;
    }

    const purchaseAmount = formData?.purchasePrice;

    let today = moment().format("YYYY-MM-DD");
    const result = getCalendarDateFromBusinessDays(today, val);
    const lastPaymentDate = moment(result.resultDate).format("YYYY-MM-DD");
    const numTerms = result.totalCalendarDays;
    const recurringAmount = (Math.ceil((purchaseAmount / val) * 100) / 100).toFixed(2);

    const newDebits = {
      daily: {
        recurringAmount: recurringAmount,
        numTerms: numTerms,
        totalBankDays: val,
        lastPaymentDate: lastPaymentDate,
      },
      weekly: {
        recurringAmount: recurringAmount,
        numTerms: val,
        totalBankDays: val,
        lastPaymentDate: moment()
          .add(val * 7, "days")
          .format("YYYY-MM-DD"),
      },
      monthly: {
        recurringAmount: recurringAmount,
        numTerms: val,
        totalBankDays: val,
        lastPaymentDate: moment()
          .add(val * 30, "days")
          .format("YYYY-MM-DD"),
      },
    };

    setDebits(newDebits);

    const newLeverage = parseFloat(calculateLeverageFromCurrentValues(newDebits).toFixed(2));
    const newTotalHoldback = parseFloat((newLeverage + currentMCAHoldback).toFixed(2));

    setFormData((prevData) => ({
      ...prevData,
      leverage: newTotalHoldback,
    }));
    setAvailableHoldBack(newLeverage);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (value === "") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: "",
      }));
      return;
    }

    const cleanValue = value.replace(/[^0-9]/g, "");

    if (cleanValue && parseInt(cleanValue, 10) > 0) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: parseInt(cleanValue, 10),
      }));
    }
  };

  const handleFundingAmountChange = (newFundingAmount: any) => {
    if (isNaN(newFundingAmount) || newFundingAmount <= 0) return;
    const factor = formData?.factor;
    const purchasePrice = formData?.purchasePrice;

    if (factor && !isNaN(factor) && factor > 0) {
      const purchaseAmount = factor * newFundingAmount;
      const formattedPurchaseAmount = parseFloat(purchaseAmount.toFixed(2));

      if (!!debits[scheduleFrequency]?.recurringAmount) {
        const updatedFormData = {
          ...formData,
          fundingAmount: newFundingAmount,
          purchasePrice: formattedPurchaseAmount,
        };
        setFormData(updatedFormData);
        const debitAmount = Number(debits[scheduleFrequency]?.recurringAmount);
        adjustTermsBasedOnFixedDebit(updatedFormData, debitAmount);
      } else if (availableHoldBack && availableHoldBack > 0) {
        const updatedFormData = {
          ...formData,
          fundingAmount: newFundingAmount,
          purchasePrice: formattedPurchaseAmount,
          leverage: availableHoldBack + (scoreboard?.monthlyMCAHoldback || 0),
        };
        setFormData(updatedFormData);
        const debitAmount = calculateDebitsbasedOnFrequencyAndTrueDeposits(
          scheduleFrequency,
          scoreboard,
          availableHoldBack
        );
        adjustTermsBasedOnFixedDebit(updatedFormData, debitAmount);
      } else {
        const updatedFormData = {
          ...formData,
          fundingAmount: newFundingAmount,
          purchasePrice: formattedPurchaseAmount,
        };
        setFormData(updatedFormData);
      }
    } else if (purchasePrice && !isNaN(purchasePrice) && purchasePrice > 0) {
      const newFactor = purchasePrice / newFundingAmount;
      const fomattedFactor = parseFloat(newFactor.toFixed(6));

      if (!!debits[scheduleFrequency]?.recurringAmount) {
        const debitAmount = Number(debits[scheduleFrequency]?.recurringAmount);
        const updatedFormData = {
          ...formData,
          factor: fomattedFactor,
          fundingAmount: newFundingAmount,
        };
        setFormData(updatedFormData);
        adjustTermsBasedOnFixedDebit(updatedFormData, debitAmount);
      } else if (availableHoldBack && availableHoldBack > 0) {
        const updatedFormData = {
          ...formData,
          factor: fomattedFactor,
          fundingAmount: newFundingAmount,
          leverage: availableHoldBack + (scoreboard?.monthlyMCAHoldback || 0),
        };
        setFormData(updatedFormData);
        const debitAmount = calculateDebitsbasedOnFrequencyAndTrueDeposits(
          scheduleFrequency,
          scoreboard,
          availableHoldBack
        );
        adjustTermsBasedOnFixedDebit(updatedFormData, debitAmount);
      } else {
        const updatedFormData = {
          ...formData,
          factor: fomattedFactor,
          fundingAmount: newFundingAmount,
        };
        setFormData(updatedFormData);
      }
    } else if (availableHoldBack && availableHoldBack > 0) {
      const debitAmount = calculateDebitsbasedOnFrequencyAndTrueDeposits(
        scheduleFrequency,
        scoreboard,
        availableHoldBack
      );
      const totalHoldback = availableHoldBack + scoreboard?.monthlyMCAHoldback;
      const numDebits = debits[scheduleFrequency]?.totalBankDays;
      const purchaseAmount = debitAmount * numDebits;
      const factor = purchaseAmount / newFundingAmount;
      const roundTo5 = (num: number) => Math.round(num * 1e5) / 1e5;
      const updatedFormData = {
        ...formData,
        fundingAmount: newFundingAmount,
        factor: factor,
        purchasePrice: purchaseAmount,
        leverage: totalHoldback,
      };
      setFormData(updatedFormData);
      adjusDebitAmountBasedOnFixedTerm(updatedFormData);
    } else {
      const updatedFormData = {
        ...formData,
        fundingAmount: newFundingAmount,
      };
      setFormData(updatedFormData);
    }

    // Upate Bank Fee
    const bankFeePercentage = formData?.bankFeePercentage;
    const bankFeeAmount = formData?.bankFeeAmount;

    if (bankFeePercentage && !isNaN(bankFeePercentage) && bankFeePercentage > 0) {
      const calculatedBankFeeAmount = (bankFeePercentage * newFundingAmount) / 100;
      const formattedBankFeeAmount = parseFloat(calculatedBankFeeAmount.toFixed(2));
      setFormData((prevData) => ({
        ...prevData,
        bankFeeAmount: formattedBankFeeAmount,
      }));
    } else if (bankFeeAmount && !isNaN(bankFeeAmount) && bankFeeAmount > 0) {
      const calculatedBankFeePercentage = (bankFeeAmount / newFundingAmount) * 100;
      const formattedBankFeePercentage = parseFloat(calculatedBankFeePercentage.toFixed(9));
      setFormData((prevData) => ({
        ...prevData,
        bankFeePercentage: formattedBankFeePercentage,
      }));
    }

    //  update commissions
    const commissionPercentage = formData?.totalCommissionPercentage;
    const commissionAmount = formData?.totalCommissionAmount;

    if (commissionPercentage && !isNaN(commissionPercentage) && commissionPercentage > 0) {
      const calculatedCommissionAmount = (commissionPercentage * newFundingAmount) / 100;
      const formattedCommissionAmount = parseFloat(calculatedCommissionAmount.toFixed(2));

      setFormData((prevData) => ({
        ...prevData,
        totalCommissionAmount: formattedCommissionAmount,
      }));
    } else if (commissionAmount && !isNaN(commissionAmount) && commissionAmount > 0) {
      const calculatedCommissionPercentage = (commissionAmount / newFundingAmount) * 100;
      const formattedCommissionPercentage = parseFloat(calculatedCommissionPercentage.toFixed(9));

      setFormData((prevData) => ({
        ...prevData,
        totalCommissionPercentage: formattedCommissionPercentage,
      }));
    }
  };

  const handleFactorChange = (newFactor: any) => {
    console.log("Factor change");
    if (isNaN(newFactor) || newFactor <= 0) return;
    const fundingAmount = formData?.fundingAmount;
    const purchaseAmount = formData?.purchasePrice;

    if (fundingAmount && !isNaN(fundingAmount) && fundingAmount > 0) {
      const purchaseAmount = newFactor * fundingAmount;
      const formattedPurchaseAmount = parseFloat(purchaseAmount.toFixed(2));

      if (!!debits[scheduleFrequency]?.recurringAmount) {
        const debitAmount = Number(debits[scheduleFrequency]?.recurringAmount);
        const updatedFormData = {
          ...formData,
          factor: newFactor,
          purchasePrice: formattedPurchaseAmount,
        };
        setFormData(updatedFormData);
        adjustTermsBasedOnFixedDebit(updatedFormData, debitAmount);
      } else if (availableHoldBack && availableHoldBack > 0) {
        const updatedFormData = {
          ...formData,
          factor: newFactor,
          purchasePrice: formattedPurchaseAmount,
          leverage: availableHoldBack + (scoreboard?.monthlyMCAHoldback || 0),
        };
        setFormData(updatedFormData);
        const debitAmount = calculateDebitsbasedOnFrequencyAndTrueDeposits(
          scheduleFrequency,
          scoreboard,
          availableHoldBack
        );
        adjustTermsBasedOnFixedDebit(updatedFormData, debitAmount);
      } else {
        const updatedFormData = {
          ...formData,
          factor: newFactor,
          purchasePrice: formattedPurchaseAmount,
        };
        setFormData(updatedFormData);
      }
    } else if (purchaseAmount && !isNaN(purchaseAmount) && purchaseAmount > 0) {
      console.log("change via purchase amount");
      const fundingAmount = purchaseAmount / newFactor;
      const formattedFundingAmount = parseFloat(fundingAmount.toFixed(2));

      if (!!debits[scheduleFrequency]?.recurringAmount) {
        const debitAmount = Number(debits[scheduleFrequency]?.recurringAmount);
        const updatedFormData = {
          ...formData,
          factor: newFactor,
          fundingAmount: formattedFundingAmount,
        };
        setFormData(updatedFormData);
        adjustTermsBasedOnFixedDebit(updatedFormData, debitAmount);
      } else if (availableHoldBack && availableHoldBack > 0) {
        const updatedFormData = {
          ...formData,
          factor: newFactor,
          fundingAmount: formattedFundingAmount,
          leverage: availableHoldBack + (scoreboard?.monthlyMCAHoldback || 0),
        };
        setFormData(updatedFormData);
        const debitAmount = calculateDebitsbasedOnFrequencyAndTrueDeposits(
          scheduleFrequency,
          scoreboard,
          availableHoldBack
        );
        adjustTermsBasedOnFixedDebit(updatedFormData, debitAmount);
      } else {
        const updatedFormData = {
          ...formData,
          factor: newFactor,
          purchasePrice: formattedPurchaseAmount,
        };
        setFormData(updatedFormData);
      }
    } else if (availableHoldBack && availableHoldBack > 0) {
      const debitAmount = calculateDebitsbasedOnFrequencyAndTrueDeposits(
        scheduleFrequency,
        scoreboard,
        availableHoldBack
      );
      const totalHoldback = availableHoldBack + scoreboard?.monthlyMCAHoldback;
      const numDebits = debits[scheduleFrequency]?.totalBankDays;
      const purchaseAmount = debitAmount * numDebits;
      const fundingAmount = purchaseAmount / newFactor;
      const updatedFormData = {
        ...formData,
        fundingAmount: fundingAmount,
        factor: newFactor,
        purchasePrice: purchaseAmount,
        leverage: totalHoldback,
      };
      setFormData(updatedFormData);
      adjusDebitAmountBasedOnFixedTerm(updatedFormData);
    } else {
      const updatedFormData = {
        ...formData,
        factor: newFactor,
      };
      setFormData(updatedFormData);
    }
  };

  const handlePurchaseAmountChange = (newPurchaseAmount: any) => {
    if (isNaN(newPurchaseAmount) || newPurchaseAmount <= 0) return;
    const fundingAmount = formData?.fundingAmount;
    const factor = formData?.factor;

    if (fundingAmount && !isNaN(fundingAmount) && fundingAmount > 0) {
      const newFactor = newPurchaseAmount / fundingAmount;
      const fomattedFactor = parseFloat(newFactor.toFixed(6));

      if (!!debits[scheduleFrequency]?.recurringAmount) {
        const debitAmount = Number(debits[scheduleFrequency]?.recurringAmount);
        const updatedFormData = {
          ...formData,
          factor: fomattedFactor,
          purchasePrice: newPurchaseAmount,
        };
        setFormData(updatedFormData);
        adjustTermsBasedOnFixedDebit(updatedFormData, debitAmount);
      } else if (availableHoldBack && availableHoldBack > 0) {
        const updatedFormData = {
          ...formData,
          factor: fomattedFactor,
          purchasePrice: newPurchaseAmount,
          leverage: availableHoldBack + (scoreboard?.monthlyMCAHoldback || 0),
        };
        setFormData(updatedFormData);
        const debitAmount = calculateDebitsbasedOnFrequencyAndTrueDeposits(
          scheduleFrequency,
          scoreboard,
          availableHoldBack
        );
        adjustTermsBasedOnFixedDebit(updatedFormData, debitAmount);
      } else {
        const updatedFormData = {
          ...formData,
          factor: fomattedFactor,
          purchasePrice: newPurchaseAmount,
        };
        setFormData(updatedFormData);
      }
    } else if (factor && !isNaN(factor) && factor > 0) {
      const newFundingAmount = newPurchaseAmount / factor;
      const fomattedFundingAmount = parseFloat(newFundingAmount.toFixed(2));

      if (!!debits[scheduleFrequency]?.recurringAmount) {
        const debitAmount = Number(debits[scheduleFrequency]?.recurringAmount);
        const updatedFormData = {
          ...formData,
          purchasePrice: newPurchaseAmount,
          fundingAmount: newFundingAmount,
        };
        setFormData(updatedFormData);
        adjustTermsBasedOnFixedDebit(updatedFormData, debitAmount);
      } else if (availableHoldBack && availableHoldBack > 0) {
        const updatedFormData = {
          ...formData,
          purchasePrice: newPurchaseAmount,
          fundingAmount: newFundingAmount,
          leverage: availableHoldBack + (scoreboard?.monthlyMCAHoldback || 0),
        };
        setFormData(updatedFormData);
        const debitAmount = calculateDebitsbasedOnFrequencyAndTrueDeposits(
          scheduleFrequency,
          scoreboard,
          availableHoldBack
        );
        adjustTermsBasedOnFixedDebit(updatedFormData, debitAmount);
      } else {
        const updatedFormData = {
          ...formData,
          purchasePrice: newPurchaseAmount,
          fundingAmount: newFundingAmount,
        };
        setFormData(updatedFormData);
      }
    } else {
      const updatedFormData = {
        ...formData,
        purchasePrice: newPurchaseAmount,
      };
      setFormData(updatedFormData);
    }
  };

  const handleBankFee = (bankFee: any, type: string) => {
    if (isNaN(bankFee) || bankFee < 0) {
      type === "percentage"
        ? setFormData((prevData) => ({ ...prevData, bankFeeAmount: 0 }))
        : setFormData((prevData) => ({ ...prevData, bankFeePercentage: 0 }));
      return;
    }

    const fundingAmount = formData?.fundingAmount;

    if (fundingAmount && !isNaN(fundingAmount) && fundingAmount > 0) {
      if (type === "percentage") {
        const bankFeeAmount = (bankFee * fundingAmount) / 100;
        const formattedBankFeeAmount = parseFloat(bankFeeAmount.toFixed(2));
        setFormData((prevData) => ({
          ...prevData,
          bankFeeAmount: formattedBankFeeAmount,
        }));
      } else {
        const bankFeePercentage = (bankFee / fundingAmount) * 100;
        const formattedBankFeePercentage = parseFloat(bankFeePercentage.toFixed(9));
        setFormData((prevData) => ({
          ...prevData,
          bankFeePercentage: formattedBankFeePercentage,
        }));
      }
    }
  };

  const handleCommissionChange = (commission: any, type: string) => {
    if (isNaN(commission) || commission < 0) {
      type === "percentage"
        ? setFormData((prevData) => ({ ...prevData, totalCommissionAmount: 0 }))
        : setFormData((prevData) => ({ ...prevData, totalCommissionPercentage: 0 }));
      return;
    }

    const fundingAmount = formData?.fundingAmount;

    if (fundingAmount && !isNaN(fundingAmount) && fundingAmount > 0) {
      if (type === "percentage") {
        const commissionAmount = (commission * fundingAmount) / 100;
        const formattedCommissionAmount = parseFloat(commissionAmount.toFixed(2));
        setFormData((prevData) => ({
          ...prevData,
          totalCommissionAmount: formattedCommissionAmount,
        }));
      } else {
        const commissionPercentage = (commission / fundingAmount) * 100;
        const formattedCommissionPercentage = parseFloat(commissionPercentage.toFixed(9));
        setFormData((prevData) => ({
          ...prevData,
          totalCommissionPercentage: formattedCommissionPercentage,
        }));
      }
    }
  };

  const handleClose = () => {
    resetFields();
    setOpen(false);
  };

  const handleAcceptedOffer = async (acceptedOffer: any) => {
    const newContractTerms = contractTerms;
    newContractTerms.applicationId = dealApplicationId;
    newContractTerms.tenantId = 1;
    newContractTerms.bankFee = acceptedOffer?.bankFeeAmount;
    newContractTerms.bankFeePercentage = acceptedOffer?.bankFeePercentage;
    newContractTerms.commissionTotal = acceptedOffer?.commissionAmount;
    newContractTerms.bankFeeCalculationThrough = "bank_fee_percentage";
    newContractTerms.paybackAmountCalculationThrough = "payback_factor";

    newContractTerms.contractTerms.collectionFrequency = acceptedOffer?.frequency;
    newContractTerms.contractTerms.collectionRecurringAmount = acceptedOffer?.recurringAmount;
    newContractTerms.contractTerms.commissionAmount = acceptedOffer?.commissionAmount;
    newContractTerms.contractTerms.commissionPercentage = acceptedOffer?.commissionPercentage;
    newContractTerms.contractTerms.funder = { id: acceptedOffer?.funderId };
    newContractTerms.contractTerms.heldbackAmount = acceptedOffer?.otherFees;
    newContractTerms.contractTerms.numberOfDebits = acceptedOffer?.numberOfPayments;
    newContractTerms.numberOfDebits = acceptedOffer?.numberOfPayments;

    newContractTerms.contractTerms.fundedAmountChange = true;
    newContractTerms.contractTerms.commissionPercentageCalculationThrough = "commission_percentage";
    newContractTerms.contractTerms.fundingDate = acceptedOffer?.fundingDate;

    newContractTerms.fundedAmount = acceptedOffer?.fundingAmount;
    newContractTerms.purchaseAmount = acceptedOffer?.paybackAmount;
    newContractTerms.paybackFactor = acceptedOffer?.factor;
    newContractTerms.estimatedPayoffDate = acceptedOffer?.estimatedPayoffDate;
    newContractTerms.contractTerms.receivablePercentage = acceptedOffer?.specifiedPercentage;

    const refiDeals = newContractTerms.contractTerms.payingOffDeals;
    let newRefiDeals: any = [];

    const refinanceAmount = acceptedOffer?.refinanceAmount || 0;

    if (refinanceAmount > 0 && refiDeals && refiDeals.length > 0) {
      const refiDeal = refiDeals[0];
      refiDeal.payingoffAmount = refinanceAmount;
      newRefiDeals = [refiDeal];
    } else {
      newRefiDeals = [];
    }

    if (newRefiDeals && newRefiDeals.length > 0) {
      newContractTerms.contractTerms.parentDealAmount = refinanceAmount;
      newContractTerms.contractTerms.payingOffDeals = newRefiDeals;
    } else {
      newContractTerms.contractTerms.parentDealAmount = 0;
      newContractTerms.contractTerms.payingOffDeals = [];
    }

    //handle external payoff
    if (acceptedOffer.externalPayOffAmount && acceptedOffer.externalPayOffAmount > 0) {
      const defaultExternalFunder = externalFunders[0];
      if (defaultExternalFunder) {
        newContractTerms.contractTerms.externalAbaNumber = defaultExternalFunder?.externalAbaNumber;
        newContractTerms.contractTerms.externalAccountNumber =
          defaultExternalFunder?.externalAccountNumber;
        newContractTerms.contractTerms.externalAmount = acceptedOffer?.externalPayOffAmount;
        newContractTerms.contractTerms.externalBankName = defaultExternalFunder?.externalBankName;
        newContractTerms.contractTerms.externalFunderId = defaultExternalFunder?.externalFunderId;
        newContractTerms.contractTerms.mcaCompany = defaultExternalFunder?.mcaCompany;
      }
    } else {
      newContractTerms.contractTerms.externalFunderId = null;
    }

    await saveFinalOffer(newContractTerms);

    //heldbacks
    const otherFees = heldbacks.filter((fee: any) => fee.type != "bank_fee");

    if (otherFees.length > 0) {
      if (otherFees.length > 0 && acceptedOffer?.otherFees && acceptedOffer?.otherFees > 0) {
        const fee = otherFees[0];
        fee.amount = acceptedOffer?.otherFees;
        fee.partyId = fee?.applicationPartyId;

        if (otherFees.length > 1) {
          for (let i = 1; i < otherFees.length; i++) {
            let remainingHeldBack = otherFees[i];
            await deleteHeldBack({
              id: remainingHeldBack.id,
              type: "",
              applicationId: dealApplicationId,
              deletingIds: [],
              callback: undefined,
            });
          }
        }

        await saveHeldback({
          offerDetails: newContractTerms,
          heldbackData: fee,
          dealApplicationId: dealApplicationId,
          callback: undefined,
        });
      } else {
        for (let i = 0; i < otherFees.length; i++) {
          let remainingHeldBack = otherFees[i];
          await deleteHeldBack({
            id: remainingHeldBack.id,
            type: "",
            applicationId: dealApplicationId,
            deletingIds: [],
            callback: undefined,
          });
        }
      }
    } else if (acceptedOffer?.otherFees && acceptedOffer?.otherFees > 0) {
      const fee = {
        amount: acceptedOffer?.otherFees,
        applicationId: dealApplicationId,
        description: "",
        partyId: acceptedOffer?.funderId || newContractTerms?.contractTerms?.funder?.funderId,
        tenantId: "1",
        type: "origination_fee",
      };
      await saveHeldback({
        offerDetails: newContractTerms,
        heldbackData: fee,
        dealApplicationId: dealApplicationId,
        callback: undefined,
      });
    }
  };

  const clearAcceptedOffer = async () => {
    const newContractTerms = contractTerms;
    newContractTerms.applicationId = dealApplicationId;
    newContractTerms.tenantId = 1;
    newContractTerms.bankFee = 0;
    newContractTerms.bankFeePercentage = 0;
    newContractTerms.commissionTotal = 0;

    newContractTerms.contractTerms.collectionFrequency = "";
    newContractTerms.contractTerms.collectionRecurringAmount = 0;
    newContractTerms.contractTerms.commissionAmount = 0;
    newContractTerms.contractTerms.commissionPercentage = 0;
    newContractTerms.contractTerms.heldbackAmount = 0;
    newContractTerms.contractTerms.numberOfDebits = 0;
    newContractTerms.numberOfDebits = 0;
    newContractTerms.contractTerms.receivablePercentage = 0;

    newContractTerms.fundedAmount = 0;
    newContractTerms.purchaseAmount = 0;
    newContractTerms.paybackFactor = 0;
    newContractTerms.estimatedPayoffDate = "";

    await saveFinalOffer(newContractTerms);
  };

  const calculateDebitsbasedOnFrequencyAndTrueDeposits = (
    frequency,
    scoreboard,
    availableHoldback
  ) => {
    const trueDeposits = scoreboard?.averageTrueDeposits || 0;
    const monthlyDebit = (availableHoldback / 100) * trueDeposits;
    let amount = 0;

    switch (frequency) {
      case "daily":
        amount = monthlyDebit / 22;
        break;
      case "weekly":
        amount = monthlyDebit / 4.3;
        break;
      case "monthly":
        amount = monthlyDebit;
        break;
      default:
        throw new Error("Unknown frequency type");
    }
    return amount;
  };

  const handleSubmit = async () => {
    const safeValue = (value: any) => (isNaN(value) || value == null ? 0 : value);

    const calculateAmountsBasedOnFrequency = (frequency, recurringAmount) => {
      let weeklyAmount = 0;
      let monthlyAmount = 0;

      switch (frequency) {
        case "daily":
          weeklyAmount = recurringAmount * 5;
          monthlyAmount = weeklyAmount * 4.33;
          break;
        case "weekly":
          weeklyAmount = recurringAmount;
          monthlyAmount = weeklyAmount * 4.33;
          break;
        case "monthly":
          weeklyAmount = recurringAmount / 4.33;
          monthlyAmount = recurringAmount;
          break;
        default:
          throw new Error("Unknown frequency type");
      }
      return { weeklyAmount, monthlyAmount };
    };

    if (isRefi && (isNaN(formData?.totalRefinance) || formData.totalRefinance <= 0)) {
      return;
    }

    if (
      !scheduleFrequency ||
      !debits[scheduleFrequency]?.lastPaymentDate ||
      !debits[scheduleFrequency]?.numTerms ||
      !debits[scheduleFrequency]?.recurringAmount ||
      !debits[scheduleFrequency]?.totalBankDays
    ) {
      return;
    }

    setLoading(true);
    try {
      const { weeklyAmount, monthlyAmount } = calculateAmountsBasedOnFrequency(
        scheduleFrequency,
        safeValue(debits[scheduleFrequency]?.recurringAmount)
      );

      const requestBody = {
        funderId: formData?.funderId || funderId,
        applicationId: dealApplicationId,
        fundingDate: formData?.fundingDate,
        term: safeValue(debits[scheduleFrequency]?.numTerms),
        frequency: scheduleFrequency,
        numberOfPayments: safeValue(debits[scheduleFrequency]?.totalBankDays),
        recurringAmount: safeValue(debits[scheduleFrequency]?.recurringAmount),
        estimatedPayoffDate: debits[scheduleFrequency]?.lastPaymentDate || "",
        weeklyAmount: weeklyAmount,
        monthlyAmount: monthlyAmount,
        status: formData?.status || "Not Sent",
        type: formData?.type || "Straight",
        paybackAmount: safeValue(formData?.purchasePrice),
        fundingAmount: safeValue(formData?.fundingAmount),
        externalPayOffAmount: safeValue(formData?.totalExternalPayoff),
        refinanceAmount: safeValue(formData?.totalRefinance),
        bankFeeAmount: safeValue(formData?.bankFeeAmount),
        bankFeePercentage: safeValue(formData?.bankFeePercentage),
        otherFees: safeValue(formData?.totalFees),
        commissionAmount: safeValue(formData?.totalCommissionAmount),
        commissionPercentage: safeValue(formData?.totalCommissionPercentage),
        specifiedPercentage: safeValue(formData?.specifiedPercentage),
        position: safeValue(formData.position),
        netFunding: safeValue(
          textData?.["Net Funding"]
            ? parseFloat(textData["Net Funding"].replace(/[^0-9.-]+/g, ""))
            : 0
        ),
        leverage: safeValue(formData?.leverage),
        factor: safeValue(formData?.factor),
      };

      if (
        requestBody?.fundingAmount < 0 ||
        requestBody?.factor === 0 ||
        requestBody.paybackAmount < 0
      ) {
        return;
      }

      if (formData?.offerKey) {
        requestBody.offerKey = formData.offerKey;
      }

      const response = await addOffer(requestBody);

      if (formData.status === "Accepted" || formData.oldStatus === "Accepted") {
        if (response?.acceptedOffer) {
          await handleAcceptedOffer(response.acceptedOffer);
        } else if (formData.oldStatus === "Accepted" && !response?.acceptedOffer) {
          await clearAcceptedOffer();
        }
        const offerDetails = await getContractTerms(dealApplicationId);
        await handleBankAmountUpdate({
          offerDetails: offerDetails,
          dealApplicationId: dealApplicationId,
        });
        await fetchRecalculatedApplication(dealApplicationId);
        await updateSyndicatorsPercentage({
          applicationId: dealApplicationId,
          reload: false,
        });
      }
      await refreshOffers();
      await resetFields();
    } catch (error) {
      console.error("Error while saving offer:", error);
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  const getContractTerms = async (dealApplicationId: any) => {
    try {
      const response = await get(`getContractTerms/${dealApplicationId}`);
      return response;
    } catch (error) {
      return {};
    }
  };

  const renderFundingForm = (
    <MDBox display={"flex"} flexDirection={"column"} gap={2}>
      <MDBox
        style={{
          width: "90%",
          marginLeft: "10px",
          marginRight: "20px",
          opacity: !scoreboard?.averageTrueDeposits ? 0.7 : 1,
          pointerEvents: !scoreboard?.averageTrueDeposits ? "none" : "auto",
        }}
      >
        <MDTypography fontWeight="bold" fontSize={15} gutterBottom>
          MCA Holdback %
          {!scoreboard?.averageTrueDeposits && (
            <MDTypography
              color="warning"
              fontSize={13}
              component="span"
              sx={{ marginLeft: "10px", fontStyle: "italic" }}
            >
              **Average True Deposits**.
            </MDTypography>
          )}
        </MDTypography>
        <MDBox sx={{ margin: "auto", paddingTop: "10px", paddingLeft: "10px" }}>
          <Slider
            value={formData?.leverage}
            onChange={(e, newValue) => {
              const minHoldback = Math.max(newValue, scoreboard?.monthlyMCAHoldback || 0);
              handleLeverageChange(e, minHoldback);
            }}
            step={1}
            min={0}
            max={100}
            valueLabelDisplay="on"
            valueLabelFormat={(value) => `${value}%`}
            sx={{
              "& .MuiSlider-track": {
                height: 3,
                border: "none",
                background:
                  formData?.leverage <= MAX_FUNDER_HOLDBACK
                    ? "#6BE600"
                    : `linear-gradient(to right,
                        #6BE600 0%,
                        #6BE600 ${greenPercentage}%,
                        #FF3B3B ${greenPercentage}%,
                        #FF3B3B 100%)`,
              },
              "& .MuiSlider-rail": {
                color: "#ccc",
                height: 3,
              },
              "& .MuiSlider-thumb": {
                backgroundColor: formData?.leverage > MAX_FUNDER_HOLDBACK ? "#FF3B3B" : "#5ACA00",
                borderColor: formData?.leverage > MAX_FUNDER_HOLDBACK ? "#FF3B3B" : "#5ACA00",
                width: 16,
                height: 16,
              },
              "& .MuiSlider-valueLabel": {
                fontSize: 12,
                background: "none",
                fontFamily: "Roboto",
                color: "#A8B8D8",
                top: -1,
              },
            }}
          />
        </MDBox>
      </MDBox>

      <MDInput
        label="Funding Date"
        name="fundingDate"
        type="date"
        value={formData.fundingDate || new Date().toISOString().split("T")[0]}
        onChange={(event) =>
          setFormData((prevData) => ({
            ...prevData,
            fundingDate: event?.target?.value,
          }))
        }
        InputLabelProps={{ shrink: true }}
        inputProps={{ style: { fontSize: 14, fontWeight: 700 } }}
      />

      <MDBox display="flex" justifyContent="space-between" gap={2}>
        <NumericFormat
          variant="standard"
          label="Funding Amount"
          name="fundingAmount"
          value={formData.fundingAmount}
          onValueChange={({ value }: any) => {
            if (isFundingAmountTypingRef) {
              const numericAmount = parseFloat(value.replace(/[^0-9.-]+/g, ""));
              debouncedFundingAmountChange(numericAmount);
            }
          }}
          onFocus={() => {
            isFundingAmountTypingRef.current = true;
          }}
          onBlur={() => {
            isFundingAmountTypingRef.current = false;
          }}
          thousandSeparator
          prefix="$"
          decimalScale={2}
          fixedDecimalScale
          allowNegative={false}
          customInput={MDInput}
          error={isNaN(formData.fundingAmount) || formData.fundingAmount <= 0}
          inputProps={{ style: { fontSize: 14, fontWeight: 700 } }}
          sx={{ flexBasis: "40%" }}
        />

        <NumericFormat
          variant="standard"
          label="Factor"
          name="factor"
          value={formData.factor}
          onValueChange={({ value }: any) => {
            if (isFactorTypingRef.current) {
              const numericFactor = parseFloat(value.replace(/[^0-9.-]+/g, ""));
              handleFactorChange(numericFactor);
            }
          }}
          onFocus={() => {
            isFactorTypingRef.current = true;
          }}
          onBlur={() => {
            isFactorTypingRef.current = false;
          }}
          fixedDecimalScale={false}
          allowNegative={false}
          error={isNaN(formData.factor) || formData.factor <= 0}
          customInput={MDInput}
          inputProps={{
            style: {
              fontSize: 14,
              fontWeight: 700,
            },
          }}
          sx={{
            flexBasis: "20%",
          }}
        />

        <NumericFormat
          variant="standard"
          label="Purchase Price"
          name="purchasePrice"
          value={formData.purchasePrice}
          onValueChange={({ value }: any) => {
            if (isPurchasePriceTypingRef.current) {
              debouncedPurchaseAmountChange(parseFloat(value.replace(/[^0-9.-]+/g, "")));
            }
          }}
          onFocus={() => {
            isPurchasePriceTypingRef.current = true;
          }}
          onBlur={() => {
            isPurchasePriceTypingRef.current = false;
          }}
          thousandSeparator
          prefix="$"
          decimalScale={2}
          fixedDecimalScale
          allowNegative={false}
          error={isNaN(formData.purchasePrice) || formData.purchasePrice <= 0}
          customInput={MDInput}
          inputProps={{
            style: {
              fontSize: 14,
              fontWeight: 700,
            },
          }}
          sx={{
            flexBasis: "40%",
          }}
        />
      </MDBox>

      <MDBox display="flex" justifyContent="space-between" gap={2}>
        <FormControl variant="standard" sx={{ m: 1, minWidth: 120, flexBasis: "50%" }}>
          <InputLabel id="demo-simple-select-standard-label">Frequency</InputLabel>
          <Select
            id="funding-calculator-select"
            name="frequency"
            value={scheduleFrequency}
            onChange={(e) => {
              setScheduleFrequency(e.target.value);
            }}
            sx={{
              "& #funding-calculator-select": {
                fontSize: 14,
                fontWeight: 700,
              },
            }}
            endAdornment={<KeyboardArrowDown />}
          >
            <MenuItem value="daily">Daily</MenuItem>
            <MenuItem value="weekly">Weekly</MenuItem>
            <MenuItem value="monthly">Monthly</MenuItem>
          </Select>
        </FormControl>

        <NumericFormat
          variant="standard"
          label="Debit Amount"
          name="debitAmount"
          value={debits[scheduleFrequency].recurringAmount || ""}
          onValueChange={({ value }: any) => {
            if (triggerRecurringAmountChange) {
              debouncedHandleAmountChange(parseFloat(value.replace(/[^0-9.-]+/g, "")));
            }
          }}
          thousandSeparator
          prefix="$"
          decimalScale={2}
          fixedDecimalScale
          allowNegative={false}
          error={
            isNaN(debits[scheduleFrequency].recurringAmount) ||
            debits[scheduleFrequency].recurringAmount <= 0
          }
          customInput={MDInput}
          inputProps={{
            style: {
              fontSize: 14,
              fontWeight: 700,
            },
          }}
          sx={{
            flexBasis: "50%",
          }}
          onFocus={() => {
            setTriggerRecurringAmountChange(true);
          }}
          onBlur={() => {
            setTriggerRecurringAmountChange(false);
          }}
        />
      </MDBox>

      <MDBox display="flex" justifyContent="space-between" gap={2}>
        <MDInput
          variant="standard"
          label="# of Payments"
          name="numPayments"
          type="number"
          value={debits[scheduleFrequency].totalBankDays || ""}
          error={
            isNaN(debits[scheduleFrequency].totalBankDays) ||
            debits[scheduleFrequency].totalBankDays <= 0
          }
          onChange={(event) => handleBankDaysChange(event?.target?.value)}
          inputProps={{
            style: { fontSize: 14, fontWeight: 700 },
            inputMode: "numeric",
            pattern: "[0-9]*",
          }}
          sx={{
            flexBasis: "33%",
          }}
        />

        <MDInput
          variant="standard"
          label={`Term  ${
            scheduleFrequency === "daily"
              ? "(Calendar Days)"
              : scheduleFrequency === "weekly"
              ? "(Weeks)"
              : "(Months)"
          }`}
          name="termDays"
          type="number"
          value={debits[scheduleFrequency].numTerms || ""}
          error={
            isNaN(debits[scheduleFrequency].numTerms) || debits[scheduleFrequency].numTerms <= 0
          }
          onChange={(event) => handleTermChange(event?.target?.value)}
          inputProps={{
            style: { fontSize: 14, fontWeight: 700 },
            inputMode: "numeric",
            pattern: "[0-9]*",
          }}
          sx={{
            flexBasis: "40%",
          }}
        />

        <MDInput
          variant="standard"
          label="Est. Payoff Date"
          name="payoffDate"
          type="date"
          value={debits[scheduleFrequency].lastPaymentDate || ""}
          onChange={handleEstimatedPayOffDate}
          InputLabelProps={{ shrink: true }}
          inputProps={{ style: { fontSize: 14, fontWeight: 700 } }}
          sx={{
            flexBasis: "33%",
          }}
        />
      </MDBox>

      <MDBox display="flex" justifyContent="space-between" gap={2}>
        <MDBox display="flex" flexBasis="50%">
          <NumericFormat
            variant="standard"
            label="Bank Fee"
            name="bankFeePercentage"
            value={formData.bankFeePercentage}
            onValueChange={({ value }: any) => {
              const bankFeePercent = parseFloat(value.replace(/[^0-9.-]+/g, ""));

              setFormData((prevData) => ({
                ...prevData,
                bankFeePercentage: isNaN(bankFeePercent) ? 0 : bankFeePercent,
              }));

              handleBankFee(parseFloat(value.replace(/[^0-9.-]+/g, "")), "percentage");
            }}
            suffix="%"
            allowNegative={false}
            error={isNaN(formData.bankFeePercentage) || formData.bankFeePercentage < 0}
            customInput={MDInput}
            inputProps={{
              style: {
                fontSize: 14,
                fontWeight: 700,
              },
            }}
          />

          <NumericFormat
            variant="standard"
            label=" "
            name="bankFeeAmount"
            value={formData.bankFeeAmount}
            onValueChange={({ value }: any) => {
              const bankFeeAmount = parseFloat(value.replace(/[^0-9.-]+/g, ""));
              setFormData((prevData) => ({
                ...prevData,
                bankFeeAmount: isNaN(bankFeeAmount) ? 0 : bankFeeAmount,
              }));
              handleBankFee(parseFloat(value.replace(/[^0-9.-]+/g, "")), "");
            }}
            thousandSeparator
            prefix="$"
            decimalScale={2}
            fixedDecimalScale
            allowNegative={false}
            error={isNaN(formData.bankFeeAmount) || formData.bankFeeAmount < 0}
            customInput={MDInput}
            inputProps={{
              style: {
                fontSize: 14,
                fontWeight: 700,
              },
            }}
          />
        </MDBox>

        <MDBox display="flex" flexBasis="50%">
          <NumericFormat
            variant="standard"
            label="Total Commission"
            name="totalCommissionPercentage"
            value={formData.totalCommissionPercentage}
            onValueChange={({ value }: any) => {
              const totalCommissionPercentage = parseFloat(value.replace(/[^0-9.-]+/g, ""));

              setFormData((prevData) => ({
                ...prevData,
                totalCommissionPercentage: isNaN(totalCommissionPercentage)
                  ? 0
                  : totalCommissionPercentage,
              }));

              handleCommissionChange(parseFloat(value.replace(/[^0-9.-]+/g, "")), "percentage");
            }}
            suffix="%"
            allowNegative={false}
            error={
              isNaN(formData.totalCommissionPercentage) || formData.totalCommissionPercentage < 0
            }
            customInput={MDInput}
            inputProps={{
              style: {
                fontSize: 14,
                fontWeight: 700,
              },
            }}
          />

          <NumericFormat
            variant="standard"
            label=" "
            name="totalCommissionAmount"
            value={formData.totalCommissionAmount}
            onValueChange={({ value }: any) => {
              const totalCommissionAmount = parseFloat(value.replace(/[^0-9.-]+/g, ""));
              setFormData((prevData) => ({
                ...prevData,
                totalCommissionAmount: isNaN(totalCommissionAmount) ? 0 : totalCommissionAmount,
              }));
              handleCommissionChange(totalCommissionAmount, "");
            }}
            thousandSeparator
            prefix="$"
            decimalScale={2}
            fixedDecimalScale
            allowNegative={false}
            error={isNaN(formData.totalCommissionAmount) || formData.totalCommissionAmount < 0}
            customInput={MDInput}
            inputProps={{
              style: {
                fontSize: 14,
                fontWeight: 700,
              },
            }}
          />
        </MDBox>
      </MDBox>

      <MDBox display="flex" flexDirection="row" flexWrap="wrap" gap={2} style={{ width: "100%" }}>
        {isRefi && (
          <MDBox style={{ width: "calc(50% - 8px)" }}>
            <NumericFormat
              variant="standard"
              label="Total Refinance"
              name="totalRefinance"
              value={formData.totalRefinance}
              onValueChange={({ value }: any) => {
                setFormData((prevData) => ({
                  ...prevData,
                  totalRefinance: parseFloat(value.replace(/[^0-9.-]+/g, "")),
                }));
              }}
              thousandSeparator
              prefix="$"
              decimalScale={2}
              fixedDecimalScale
              allowNegative={false}
              error={isRefi && (isNaN(formData.totalRefinance) || formData.totalRefinance <= 0)}
              customInput={MDInput}
              inputProps={{
                style: {
                  fontSize: 14,
                  fontWeight: 700,
                },
              }}
              fullWidth
            />
          </MDBox>
        )}

        <MDBox style={{ width: "calc(50% - 8px)" }}>
          <NumericFormat
            variant="standard"
            label="Specified Percentage"
            name="specifiedPercentage"
            value={formData.specifiedPercentage}
            onValueChange={({ value }: any) => {
              const specifiedPercentage = parseFloat(value.replace(/[^0-9.-]+/g, ""));

              setFormData((prevData) => ({
                ...prevData,
                specifiedPercentage: isNaN(specifiedPercentage) ? 0 : specifiedPercentage,
              }));
            }}
            suffix="%"
            allowNegative={false}
            error={isNaN(formData.specifiedPercentage) || formData.specifiedPercentage < 0}
            customInput={MDInput}
            inputProps={{
              style: {
                fontSize: 14,
                fontWeight: 700,
              },
            }}
          />
        </MDBox>

        <MDBox style={{ width: "calc(50% - 8px)" }}>
          <NumericFormat
            variant="standard"
            label="Total External Payoff"
            name="totalExternalPayoff"
            value={formData.totalExternalPayoff}
            onValueChange={({ value }: any) => {
              setFormData((prevData) => ({
                ...prevData,
                totalExternalPayoff: parseFloat(value.replace(/[^0-9.-]+/g, "")),
              }));
            }}
            thousandSeparator
            prefix="$"
            decimalScale={2}
            fixedDecimalScale
            allowNegative={false}
            error={isNaN(formData.totalExternalPayoff) || formData.totalExternalPayoff < 0}
            customInput={MDInput}
            inputProps={{
              style: {
                fontSize: 14,
                fontWeight: 700,
              },
            }}
            fullWidth
          />
        </MDBox>

        <MDBox style={{ width: "calc(50% - 8px)" }}>
          <NumericFormat
            variant="standard"
            label="Other Fees"
            name="totalFees"
            value={formData.totalFees}
            onValueChange={({ value }: any) => {
              setFormData((prevData) => ({
                ...prevData,
                totalFees: parseFloat(value.replace(/[^0-9.-]+/g, "")),
              }));
            }}
            thousandSeparator
            prefix="$"
            decimalScale={2}
            fixedDecimalScale
            allowNegative={false}
            error={isNaN(formData.totalFees) || formData.totalFees < 0}
            customInput={MDInput}
            inputProps={{
              style: {
                fontSize: 14,
                fontWeight: 700,
              },
            }}
            fullWidth
          />
        </MDBox>

        <MDInput
          variant="standard"
          label={"Position"}
          name="position"
          type="number"
          value={formData.position}
          onChange={(event) => {
            setFormData((prevData) => ({
              ...prevData,
              position: event.target.value,
            }));
          }}
          inputProps={{
            style: { fontSize: 14, fontWeight: 700 },
            inputMode: "numeric",
            pattern: "[0-9]*",
          }}
          sx={{
            flexBasis: "40%",
          }}
        />
      </MDBox>
    </MDBox>
  );

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-paper": {
            position: "fixed",
            right: 0,
            margin: "auto",
            width: "500px",
            borderRadius: 0,
            maxHeight: "none",
            height: "calc(100vh - 30px)",
          },
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}
        >
          <CloseIcon />
        </IconButton>

        <DialogTitle>Funding Calculator</DialogTitle>

        <DialogContent>
          <MDBox display="flex" flexDirection="column" gap={1} paddingTop={1} marginTop={-2}>
            <MDBox sx={{ marginBottom: "-3px" }}>
              <DefaultDoughnutChart
                height={220}
                chart={{
                  labels: isRefi
                    ? [
                        "Profit",
                        "Net Funding",
                        "Total Fees",
                        "Refinance",
                        "External Payoff",
                        "Commission",
                      ]
                    : ["Profit", "Net Funding", "Total Fees", "External Payoff", "Commission"],
                  datasets: calculateChartData(),
                  cutout: 98,
                }}
                textData={textData}
              />
            </MDBox>
            {renderFundingForm}
          </MDBox>
        </DialogContent>

        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            paddingRight: 3,
          }}
        >
          <MDButton
            onClick={handleClose}
            color="dark"
            variant="contained"
            sx={{ textTransform: "none" }}
          >
            Close
          </MDButton>
          <MDButton
            onClick={handleSubmit}
            color="primary"
            variant="contained"
            sx={{ textTransform: "none" }}
          >
            {"+"} Save Offer
          </MDButton>
        </DialogActions>
      </Dialog>
      {isLoading && <FullPageLoader />}
    </>
  );
};

export default offersFundingCalculator;
